import { render, staticRenderFns } from "./ProfileTitleComponent.vue?vue&type=template&id=4096ca8b"
import script from "./ProfileTitleComponent.vue?vue&type=script&lang=js"
export * from "./ProfileTitleComponent.vue?vue&type=script&lang=js"
import style0 from "./ProfileTitleComponent.vue?vue&type=style&index=0&id=4096ca8b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports